// extracted by mini-css-extract-plugin
export default {"ipp":"ipp__GMAW4","facebook":"facebook___nquD","google":"google__Uk9h_","vk":"vk__gH_Pl","ok":"ok__qgej_","apple":"apple__sAONV","mobilecity":"mobilecity__sIvCY","village":"village__bvHSZ","herocity":"herocity__oYGPP","onyx":"onyx__raUzu","ingame":"ingame__PDsis","ippLarge":"ippLarge__Wh2Xg"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"ipp\":\"ipp__GMAW4\",\"facebook\":\"facebook___nquD\",\"google\":\"google__Uk9h_\",\"vk\":\"vk__gH_Pl\",\"ok\":\"ok__qgej_\",\"apple\":\"apple__sAONV\",\"mobilecity\":\"mobilecity__sIvCY\",\"village\":\"village__bvHSZ\",\"herocity\":\"herocity__oYGPP\",\"onyx\":\"onyx__raUzu\",\"ingame\":\"ingame__PDsis\",\"ippLarge\":\"ippLarge__Wh2Xg\"}";
        // 1787130558116
        var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  